/** 内容类型的中文口径，供底栏 chips / 记忆面板等展示层共用 */

export const ITEM_TYPE_LABELS: Record<string, string> = {
  video: '视频',
  comic: '漫画',
  novel: '小说',
  post: '图文',
  anime: '动漫',
  gallery: '图集',
  microdrama: '短剧',
};

export const ITEM_TYPE_UNITS: Record<string, string> = {
  video: '部',
  comic: '部',
  novel: '本',
  post: '条',
  anime: '部',
  gallery: '套',
  microdrama: '部',
};

export const ITEM_TYPE_ORDER = [
  'video',
  'comic',
  'novel',
  'post',
  'anime',
  'gallery',
  'microdrama',
];

export function itemTypeLabel(itemType?: string | null, fallback = '内容'): string {
  const key = (itemType || '').trim();
  return ITEM_TYPE_LABELS[key] || fallback;
}
